module.exports = __webpack_public_path__ + "24048eb696fa6e265f6b793efbb66105.pdf";